import { render } from "./MenuRental.vue?vue&type=template&id=f3aa87bc"
import script from "./MenuRental.vue?vue&type=script&lang=js"
export * from "./MenuRental.vue?vue&type=script&lang=js"

import "./MenuRental.vue?vue&type=style&index=0&id=f3aa87bc&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__